<div class="dialog">
  <div class="header">
    <h3>CSV Format Example</h3>
    <app-icon class="close se-icon-button" (click)="close()" src="close"></app-icon>
  </div>
  <div class="dialog-content">
    <h3 class="text-center">Fill out the table with lead information</h3>
    <p class="first-p">Fields marked with an asterisk (*) are required</p>
    <div class="example-table">

      <div class="table-header">Business Name*</div>
      <div class="table-header">Phone Number*</div>
      <div class="table-header">Email</div>
      <div class="table-header">Street Address*</div>
      <div class="table-header">Unit</div>
      <div class="table-header">City*</div>
      <div class="table-header">State*</div>
      <div class="table-header">ZIP*</div>
      <div class="table-header">Job Type</div>
      <div class="last-column table-header">Notes</div>

      <div>ABC Roofing</div>
      <div>555-123-4567</div>
      <div>contact@abc.com</div>
      <div>123 Main St</div>
      <div></div>
      <div>Birmingham</div>
      <div>AL</div>
      <div>35203</div>
      <div>Roofing</div>
      <div class="last-column">Needs estimate</div>

      <div class="last-row">XYZ Plumbing</div>
      <div class="last-row">555-987-6543</div>
      <div class="last-row"></div>
      <div class="last-row">456 Oak Ave</div>
      <div class="last-row">Suite 2</div>
      <div class="last-row">Montgomery</div>
      <div class="last-row">Alabama</div>
      <div class="last-row">36104</div>
      <div class="last-row">Plumbing</div>
      <div class="last-row last-column">Emergency call</div>

    </div>
    <p class="second-p">Download a ready made template</p>
    <a class="d-none" #download href="assets/lead-example.csv" download="lead-example.csv"></a>
    <button class="download-button" mat-flat-button color="primary" (click)="downloadExample()">Download</button>
  </div>
</div>
